<template>
  <v-main style="height: 100vh; overflow-y: hidden">
    <div id="particles-js" />
    <v-navigation-drawer
      fixed
      right
      width="480"
      class="px-16"
      color="primary"
    >
      <kinesis-container>
        <v-container>
          <kinesis-element
            :strength="15"
            type="depth"
          >
            <v-row
              style="height: 80vh"
              align="center"
            >
              <v-col cols="12">
                <v-form v-model="loginForm">
                  <v-card
                    class="card"
                    color="#6B1930"
                  >
                    <v-card-title
                      class="d-block"
                      align="center"
                    >
                      <img
                        src="@/assets/img/logo-puebla.png"
                        width="140"
                        class="logo mb-8"
                        alt="img"
                      >
                      <div class="font-weight-bold text-h6 justify-center primary--text">
                        Inicio de sesión
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <v-form v-model="loginForm">
                        <v-text-field
                          v-model="name"
                          rounded
                          filled
                          dense
                          label="Usuario"
                          background-color="primary"
                          color="secondary"
                        />
                        <v-text-field
                          v-model="password"
                          rounded
                          filled
                          dense
                          label="Contraseña"
                          type="password"
                          background-color="primary"
                          color="secondary"
                          :rules="passwordRules"
                        />
                      </v-form>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                      <v-container>
                        <v-row>
                          <v-col
                            cols="8"
                            offset-md="2"
                            align="center"
                          >
                            <v-btn
                              color="primary"
                              class="mb-4 secondary--text"
                              block
                              :disabled="!loginForm || loading"
                              @click="triggerLogin()"
                            >
                              Iniciar sesión
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-col>
            </v-row>
          </kinesis-element>
        </v-container>
      </kinesis-container>
    </v-navigation-drawer>
    <div class="white--text armeria font-weight-black">
      Confiabilidad
    </div>
  </v-main>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import 'particles.js';
import sha1 from 'sha1';
import { mapActions } from 'vuex';
import { textAnimation } from '../plugins/anime';

export default {
  name: 'LoginView',
  data() {
    return {
      loginForm: false,
      loading: false,
      name: '',
      password: '',
      emailRules: [(v) => !!v || 'Este campo es requerido.', (v) => /.+@.+\..+/.test(v) || 'Ingrese un correo electrónico válido.'],
      passwordRules: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  mounted() {
    this.initParticles();
    textAnimation();
  },

  methods: {
    ...mapActions(['login']),

    initParticles() {
      window.particlesJS('particles-js', {
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              value_area: 800,
            },
          },
          color: {
            value: '#ffffff',
          },
          shape: {
            type: 'circle',
            stroke: {
              width: 0,
              color: '#000000',
            },
            polygon: {
              nb_sides: 5,
            },
            image: {
              src: 'img/github.svg',
              width: 100,
              height: 100,
            },
          },
          opacity: {
            value: 0.5,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: 3,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false,
            },
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: '#ffffff',
            opacity: 0.4,
            width: 1,
          },
          move: {
            enable: true,
            speed: 6,
            direction: 'none',
            random: false,
            straight: false,
            out_mode: 'out',
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: 'canvas',
          events: {
            onhover: {
              enable: true,
              mode: 'repulse',
            },
            onclick: {
              enable: true,
              mode: 'push',
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 400,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: true,
      });
    },

    async triggerLogin() {
      this.loading = true;

      await this.login({
        loginField: this.name,
        passwordField: sha1(this.password).toUpperCase(),
      });

      this.loading = false;
    },
  },
};
</script>

<style scoped>
    #particles-js {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #6B1930;
    }
    img {
        -webkit-filter: drop-shadow(5px 5px 5px #666666);
        filter: drop-shadow(5px 5px 5px #666666);
    }
    .armeria {
        position: fixed;
        bottom: 0;
        left: 48px;
        font-size: 96px;
        opacity: 0.78;
        text-shadow: 4px 4px 8px black;
    }
    .card {
        -webkit-box-shadow: 0px 48px 24px -32px rgba(107, 25, 48, 0.61) !important;
        box-shadow: -1px 50px 48px -30px rgba(107, 25, 48, 0.61) !important;
    }
</style>
